// Survey response transformer - standalone with no dependencies except SurveyJS
if (!window.eqx) {
    window.eqx = { surveyJS: {} };
}
if (!window.eqx.surveyJS) {
    window.eqx.surveyJS = {};
}
window.eqx.surveyJS.transformer = {
    cleanupLabel: function(field) {
        const label = typeof field.name == 'number' ? field.title + ' #' + (field.name + 1) : field.title
        return label.replace(/row .*?, column/, '').trim()
    },
    transformResponse: function(data, fullData, additionalParameters) {
        let response = additionalParameters ? additionalParameters : {}
        let fields = []
        fullData.forEach(function(field) {
            fields = fields.concat(eqx.surveyJS.transformer.transformResponseField(field))
        })
        response.fields = fields
        response.rawData = JSON.stringify(data)
        return response
    },
    transformResponseField: function(field, labelStack = [], nameStack = []) {
        if (field.isNode && Array.isArray(field.data)) {
            //is it just one of those choice things? if so ignore
            let hasOnlyOneChoiceChild =
                field.data.length == 1 &&
                field.data.every(function(childField) {
                    return childField.title == 'Choice'
                })
            if (hasOnlyOneChoiceChild) {
                return eqx.surveyJS.transformer.transformResponseFieldSingle(field, labelStack, nameStack)
            }
            //invesitgate children
            let firstPassFields = []
            let hadNodeChildren = false
            field.data.forEach(function(childField) {
                    const newLabelStack = labelStack.concat([eqx.surveyJS.transformer.cleanupLabel(field)])
                    const newNameStack = nameStack.concat([field.name])
                    hadNodeChildren = hadNodeChildren || childField.isNode
                    firstPassFields = firstPassFields.concat(
                        eqx.surveyJS.transformer.transformResponseField(childField, newLabelStack, newNameStack)
                    )
                })
                //no fields returned, skip
            if (firstPassFields.length == 0) {
                return []
            }
            //some children were nodes in themselves, return them
            if (hadNodeChildren) {
                return firstPassFields
            }
            //were any fields non-trivial? if so we have to return them all
            const hasNonTrivialChildren = firstPassFields.some(function(field) {
                return (
                    field.fieldValueType != 'text' ||
                    (field.fieldDisplayValue != null && field.fieldDisplayValue != field.fieldValue)
                )
            })
            if (hasNonTrivialChildren) {
                return firstPassFields
            }
            //if we're still here we can aggregate the children
            let aggregatedValue = field.data
                .map(function(childField) {
                    return childField.title + ': ' + childField.displayValue
                })
                .join('\r\n')

            let aggregatedField = {
                name: field.name,
                title: field.title,
                value: aggregatedValue,
                displayValue: aggregatedValue,
            }
            return eqx.surveyJS.transformer.transformResponseFieldSingle(aggregatedField, labelStack, nameStack)
        } else {
            return eqx.surveyJS.transformer.transformResponseFieldSingle(field, labelStack, nameStack)
        }
    },
    transformResponseFieldSingle: function(field, labelStack = [], nameStack = []) {
        let label = labelStack.concat([eqx.surveyJS.transformer.cleanupLabel(field)]).join(' > ')
        let name = nameStack.concat([field.name]).join('.')
        let value = field.value
        let displayValue = field.displayValue
        let fileValue = null

        //collect array of fields to return
        let fields = []

        //is value an array?
        if (Array.isArray(value)) {
            //collect any trivial text items
            const strVals = []
                //loop through and look for any files
            for (let x = 0; x < value.length; x++) {
                const i = x + 1
                const item = value[x]
                    //is it a file?
                if (item && item.content && item.type) {
                    file = item
                    let type = 'file'
                    if (file.type.substring(0, 'image/'.length) === 'image/') {
                        type = 'image'
                    }
                    if (file.content.substring(0, 'data:'.length) == 'data:') {
                        file.content = file.content.substring(file.content.indexOf(',') + 1)
                    }
                    fileValue = {
                        contentType: file.type,
                        fileName: file.name ? file.name : null,
                        fileContent: file.content,
                    }
                    fields.push({
                        providerFieldID: name ? name : null,
                        fieldName: (label ? label : 'File') + (value.length > 1 ? ' (' + i + ')' : ''),
                        fieldValueType: type,
                        fieldValue: null,
                        fieldValueFile: fileValue,
                    })
                } else {
                    //not a file, add to string array to be joined and returned as text
                    strVals.push(item)
                }
            }
            //if there were no additional values, finish here
            if (strVals.length == 0) {
                return fields
            }
            //else make the string values the value and carry on
            value = strVals.join(', ')
            displayValue = null
        } else if (typeof value == 'object') {
            //is display value a string? can we use that?
            if (typeof displayValue == 'string') {
                value = displayValue
                displayValue = null
            } else {
                //value and displayValue are objects, but if we're here then presumably isNode is false and it should just be simple strings, collect them
                value = Object.keys(displayValue)
                    .map(function(key) {
                        return key + ': ' + displayValue[key]
                    })
                    .join('\r\n')
                displayValue = null
            }
        }

        //ignore undefined values (probably static text)
        if (value === undefined) return []

        //only flat values left, start by assuming text and seeing if we can match the value
        let type = 'text'
        if (value.toString().substring(0, 'data:image/'.length) == 'data:image/') {
            //image in base 64, likely signature
            type = 'image'
            fileValue = {
                contentType: value.substring('data:'.length, value.indexOf(';')),
                fileContent: value.substring(value.indexOf(',') + 1),
            }
            value = null
            displayValue = null
        } else if (typeof field.value == 'number') {
            type = field.value % 1 === 0 ? 'integer' : 'float'
        } else if (typeof field.value == 'boolean') {
            type = 'boolean'
        } else {
            //assume it's text
            value = displayValue ? String(displayValue) : String(value)
                //check if it's a date
            if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
                type = 'date'
            } else if (value.match(/^\d{2}:\d{2}(:\d{2})?$/)) {
                type = 'time'
            } else if (value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/)) {
                type = 'datetime'
            } else if (value.match(/^#[0-9a-fA-F]{6}$/)) {
                type = 'colour'
            }
        }
        //if the display value is sifferent to the field value, save the displayValue
        if (field.value == field.displayValue) displayValue = null

        //ready
        fields.push({
            providerFieldID: name,
            fieldName: label,
            fieldValueType: type,
            fieldValueFile: fileValue,
            fieldValue: value,
            fieldDisplayValue: displayValue,
        })
        return fields
    }
}